<template>
    <div class="col-md-3 col-sm-6 col-xs-12">
      <!-- <div class="panel panel-dark panel-colorful">
            <div class="panel-body text-center">
                <p class="text-uppercase mar-btm text-sm">Visit Today</p>
                <i class="fa fa-users fa-5x"></i>
                <hr>
                <p class="h2 text-thin">254,487</p>
                <small><span class="text-semibold">7%</span> Higher than yesterday</small>
            </div>
        </div> -->
      <div class="info-box">
        <span class="info-box-icon bg-secondary elevation-1"
          ><i class="fas fa-cloud"></i
        ></span>

        <div class="info-box-content">
          <span class="info-box-text text-bold">Total Tickets</span>
          <span class="info-box-number">
            {{ LifetimeTickets }}
          </span>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "ticket-counter-lifetime",
  data() {
    return {
      LifetimeTickets: 0,
    };
  },
};
</script>

<style lang="scss" scoped>
.panel {
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.05);
  border-radius: 0;
  border: 0;
  margin-bottom: 24px;
}

.panel-dark.panel-colorful {
  background-color: #3b4146;
  border-color: #3b4146;
  color: #fff;
}

.panel-danger.panel-colorful {
  background-color: #f76c51;
  border-color: #f76c51;
  color: #fff;
}

.panel-primary.panel-colorful {
  background-color: #5fa2dd;
  border-color: #5fa2dd;
  color: #fff;
}

.panel-info.panel-colorful {
  background-color: #4ebcda;
  border-color: #4ebcda;
  color: #fff;
}

.panel-body {
  padding: 25px 20px;
}

.panel hr {
  border-color: rgba(0, 0, 0, 0.1);
}

.mar-btm {
  margin-bottom: 15px;
}

h2,
.h2 {
  font-size: 28px;
}

.small,
small {
  font-size: 85%;
}

.text-sm {
  font-size: 0.9em;
}

.text-thin {
  font-weight: 300;
}

.text-semibold {
  font-weight: 600;
}
</style>